<template>
  <div class="sum-selector">
    <div class="row">
      <div class="column column-50" v-for="sumValue in scale.slice(1,3).reverse()" :key="sumValue">
        <button class="button button-outline sum-value" :class="{ active: sumValue === sum }" :value="sumValue" @click="changeSelectedSum">{{ activeCurrency === 'USD' ? symbol + sumValue : sumValue + symbol }}</button>
      </div>
    </div>
    <div class="row">
      <div class="column column-50" v-for="sumValue in scale.slice(0,1)" :key="sumValue">
        <button class="button button-outline sum-value" :class="{ active: sumValue === sum }" :value="sumValue" @click="changeSelectedSum">{{ activeCurrency === 'USD' ? symbol + sumValue : sumValue + symbol }}</button>
      </div>
      <div class="column column-50">
        <input type="text" class="other-sum" :class="{ active: !inScale || otherSumActive, error: errors.has('sum') }" :placeholder="labels['otherSum']" name="sum" autocomplete="off" :value="otherSumActive ? sum : ''" @input="changeOtherSum">
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { LABELS, VALIDATION_MESSAGES } from '@/settings'

export default {
  data: function () {
    return {
      otherSumActive: false
    }
  },
  computed: {
    inScale: function () {
      return this.scale.indexOf(this.sum) > -1
    },
    ...mapState({
      sum: state => state.donation.sum,
      activeCurrency: state => state.donation.currency,
      scale: state => state.currencies[state.donation.currency].scale_en,
      symbol: state => state.currencies[state.donation.currency].symbol,
      lang: state => state.language,
      labels: state => LABELS[state.language]
    })
  },
  methods: {
    changeOtherSum (e) {
      this.otherSumActive = true
      this.changeSum(e)
    },
    changeSelectedSum (e) {
      this.otherSumActive = false
      this.changeSum(e)
    },
    changeSum (e) {
      const value = parseInt(e.target.value)
      const change = {
        donation: {
          sum: value
        },
        step: 'form'
      }
      if (value > 0) {
        this.$validator.validateAll().then((result) => {
          if (result && value > 0) {
            this.$store.commit('updateState', change)
          }
        })
      }
    }
  },
  watch: {
    sum (sum) {
      if (!this.otherSumActive && !this.inScale) this.otherSumActive = true
    }
  },
  mounted () {
    const lang = this.lang
    this.$validator.localize(lang, VALIDATION_MESSAGES[lang])
  }
}
</script>

<style scoped>
.oi-donate .sum-selector {
  margin-left: 3px;
  margin-right: 3px;
}
.oi-donate .sum-selector .row {
  margin-left: -3px;
  width: calc(100% + 6px);
  flex-direction: row;
}

.oi-donate .row .column:first-child { padding: 0 5px 0 0; }
.oi-donate .row .column:last-child { padding: 0 0 0 5px; }
.oi-donate .sum-selector button.sum-value,
.oi-donate .sum-selector .other-sum {
  margin-bottom: 10px;
  padding: 0 10px;
  width: 100%;
  height: 58px!important;
  color: #ABBCC1;
  background: #fff!important;
  border: 4px solid #EFF2F3!important;
  font-family: CoFo Sans;
  font-size: 30px;
  font-weight: 900;
  line-height: 30px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  border-radius: 0;
  transition: .3s cubic-bezier(0,0,0,1);
}

.oi-donate .sum-selector button.sum-value.active,
.oi-donate .sum-selector .other-sum.active,
.oi-donate .sum-selector .other-sum:focus {
  background: #FF6F37!important;
  border: 4px solid #FF6F37!important;
  color: #fff;
  border: none;
}

.oi-donate .sum-selector .other-sum {
  font-size: 20px;
  text-transform: none;
  text-align: center;
}

.oi-donate .sum-selector .other-sum::placeholder {
  color: #ABBCC1;
}

.oi-donate .sum-selector .other-sum.active::placeholder,
.oi-donate .sum-selector .other-sum:focus::placeholder {
  color: #fff;
}
</style>
